#root {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
  align-items: center;
}

#header {
  width: 100%;
}

.DashboardOverview {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
  place-items: 3;
  width: 1000px;
}

.DashboardCard {
  flex-grow: 2;
  width: 300px;
  height: 220px;
  border: 2px solid gray;
  margin-left: 15px;
  margin-top: 15px;
  background-color: #eee;
}

.DashboardCard:hover {
  background-color: #ddd;
}
